import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.813 4.5H18V18H3.375A3.375 3.375 0 0 1 0 14.625V3.375A3.375 3.375 0 0 1 3.375 0h11.25v2.813H2.813zm11.812 8.156a1.406 1.406 0 1 0 0-2.813 1.406 1.406 0 0 0 0 2.813",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }